import React, { useEffect, useState } from 'react';

const ModalBase = ({ isOpen, closeModal, children }) => {
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setTimeout(() => setAnimate(true), 100);
      document.body.style.overflow = 'hidden';
    } else {
      setAnimate(false);
      const timer = setTimeout(() => setVisible(false), 500);
      document.body.style.overflow = 'auto';
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  if (!visible) return null;

  return (
    <div
      className={`modal-overlay ${animate ? 'fadeIn' : 'fadeOut'}`}
      onClick={handleOverlayClick}>
      <div
        className={`modal-content ${animate ? 'slide-in' : 'slide-out'}`}>
        <button
          className='modal-close'
          onClick={closeModal}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalBase;
